<div class="row">
  <div class="col-12">
    <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy table-sm">
  <thead>
    <tr>
      <th scope="col">Licença Expedida</th>
      <th scope="col">Número da licença</th>
      <th scope="col">Data da licença</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of exigenciaObras?.LicencaAmbientalSim">
      <td>
        <span *ngIf="!item.editavel">
          {{funcaoService.obterNomePorChave(opcoesTipoLicenca, item.TipoLicenciamento)}}
        </span>
        <select *ngIf="item.editavel" [compareWith]="compareFn" class="form-control"
          [(ngModel)]="item.TipoLicenciamento" [ngModelOptions]="{standalone: true}">
          <option *ngFor="let item of opcoesTipoLicenca" [ngValue]="item.id">{{item.nome}}</option>
        </select>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.NumLicenca}}</span>
        <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.NumLicenca"
          [ngModelOptions]="{standalone: true}">
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.DataLicenca}}</span>
        <p-calendar (onFocus)="onFocusDate()" *ngIf="item.editavel" [(ngModel)]="itemAtual.DataLicenca"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string" dateFormat="dd/mm/yy"
          [showOnFocus]="true">
        </p-calendar>
      </td>

      <td class="text-right">
        <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>